<template>
    <p>{{Lang.get('messages.block_confirmation')}} <span v-if="message">( {{message}} )</span>؟</p>
</template>

<script>
    export default {
        props: ["message"]
    };

</script>

<style>
</style>
